﻿export default {
  description:
    'Your Clear Skin Specialist will add these items to your next regimen order.',
  submit: 'Submit',
};
